// (function () {
//   /*
//    * Broadcast Theme – Membership Enforcement
//    * Clean version with NO auto fetch patching
//    */

//   const MEMBERSHIP_VARIANTS = [50543419359510, 50543417852182];
//   const GIFT_VARIANT = 50543395438870;
//   const DISCOUNT_CODE = "MEMBER15";

//   let isRunning = false; // prevents double execution

//   async function getCart() {
//     return fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
//   }

//   async function applyDiscount() {
//     document.cookie = `discount_code=${DISCOUNT_CODE};path=/`;
//   }

//   async function removeDiscountAndGift() {
//     document.cookie = "discount_code=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";

//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         updates: { [GIFT_VARIANT]: 0 },
//         discount: ""
//       })
//     });
//   }

//   async function addGift() {
//     await fetch("/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         items: [{ id: GIFT_VARIANT, quantity: 1 }]
//       })
//     });
//   }

//   // async function enforceMembershipRequirement() {
//   //   if (isRunning) return;
//   //   isRunning = true;

//   //   try {
//   //     const cart = await getCart();
    
//   //     const hasMembership = cart.items.some(item =>
//   //       MEMBERSHIP_VARIANTS.includes(item.variant_id)
//   //     );
    
//   //     const hasGift = cart.items.some(
//   //       item => item.variant_id === GIFT_VARIANT
//   //     );
    
//   //     const hasDiscount = cart.discount_codes?.some(
//   //       d => d.code.toUpperCase() === DISCOUNT_CODE
//   //     );
    
//   //     // ❌ No membership → remove gift + discount
//   //     if (!hasMembership) {
//   //       if (hasGift || hasDiscount) {
//   //         await removeDiscountAndGift();
//   //       }
//   //       return;
//   //     }
    
//   //     // 🎁 Membership exists → add gift if missing
//   //     if (!hasGift) {
//   //       await addGift();
//   //     }
    
//   //     // ✅ Membership exists → ensure discount
//   //     if (!hasDiscount) {
//   //       await applyDiscount();
//   //     }
    
//   //   } catch (err) {
//   //     console.error("Membership enforcement failed:", err);
//   //   } finally {
//   //     isRunning = false;
//   //   }
    
//   // }

//   // ✅ Run once on page load
  
//   async function enforceMembershipRequirement() {
//     if (isRunning) return;
//     isRunning = true;
  
//     try {
//       const cart = await getCart();
  
//       const hasMembership = cart.items.some(item =>
//         MEMBERSHIP_VARIANTS.includes(item.variant_id)
//       );
  
//       const hasGift = cart.items.some(
//         item => item.variant_id === GIFT_VARIANT
//       );
  
//       const hasDiscount = cart.discount_codes?.some(
//         d => d.code.toUpperCase() === DISCOUNT_CODE
//       );
  
//       // ❌ No membership → cleanup only (NO reload)
//       if (!hasMembership) {
//         if (hasGift || hasDiscount) {
//           await removeDiscountAndGift();
//         }
//         membershipReloaded = false; // reset for future adds
//         return;
//       }
  
//       // 🎁 Membership JUST added → add gift + reload ONCE
//       if (hasMembership && !hasGift) {
//         await addGift();
  
//         const updatedCart = await getCart();
//         const updatedHasDiscount = updatedCart.discount_codes?.some(
//           d => d.code.toUpperCase() === DISCOUNT_CODE
//         );
  
//         if (!updatedHasDiscount) {
//           await applyDiscount();
//         }
  
//         if (!membershipReloaded) {
//           membershipReloaded = true;
//           location.reload(); // ✅ ONLY reload that ever happens
//         }
  
//         return;
//       }
  
//       // ✅ Membership exists → ensure discount (NO reload)
//       if (!hasDiscount) {
//         await applyDiscount();
//       }
  
//     } catch (err) {
//       console.error("Membership enforcement failed:", err);
//     } finally {
//       isRunning = false;
//     }
//   }
  
  
//   document.addEventListener("DOMContentLoaded", enforceMembershipRequirement);

//   // ✅ Run ONLY when the theme says the cart changed
//   document.addEventListener("theme:cart:change", enforceMembershipRequirement);

// })();


// Cart icon click on dock - opens cart drawer

document.addEventListener('click', function (e) {
  if (e.target.closest('.dock-item--cart')) {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
      bubbles: true
    }));
    document.dispatchEvent(new CustomEvent('theme:cart-drawer:open', {
      bubbles: true
    }));
  }
});